import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import Illustration from '../assets/illustration.png';

import { LinkButton } from '@/src/components/Button';
import { desktopBreakpoint } from '@/src/domains/shared/breakpoints';
import { Title } from '@/src/views/InternationalGlobalPayroll/slices/ManagePayrollSlice';

const Section = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '90px', '130px')};
  background-image: var(--colors-purpleMinsk);
  text-align: center;
  position: relative;
  overflow: hidden;

  ${Title} {
    max-width: 600px;
    margin: 0 auto;
    color: var(--colors-blank);
  }
`;

const CTAButton = styled(LinkButton).attrs({
  withBackground: true,
  textWhite: true,
  chevron: true,
  withBorder: true,
  borderWidth: '1px',
  borderColor: 'turquoise',
})`
  margin-top: 50px;
`;

const LeftIllustrationWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  ${desktopBreakpoint(css`
    display: none;
  `)}
`;

const RightIllustrationWrapper = styled(LeftIllustrationWrapper)`
  position: absolute;
  left: unset;
  right: 0;

  img {
    transform: scale(-1, 1);
  }
`;

export function CtaSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, ctaLabel, ctaLink } = primary;

  return (
    <Section>
      <ContentContainer>
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        {ctaLabel && ctaLink && (
          <CTAButton label={ctaLabel} href={ctaLink?.url} target={ctaLink?.target} />
        )}

        <LeftIllustrationWrapper>
          <Image
            src={Illustration.src}
            alt={Illustration.alt || ''}
            width={Illustration.width}
            height={Illustration.height}
            quality="100"
          />
        </LeftIllustrationWrapper>
        <RightIllustrationWrapper>
          <Image
            src={Illustration.src}
            alt={Illustration.alt || ''}
            width={Illustration.width}
            height={Illustration.height}
            quality="100"
          />
        </RightIllustrationWrapper>
      </ContentContainer>
    </Section>
  );
}
